// import config
import axios from '../config/axios';

export const getSourceOfFund = async (reqData) => {
    try {
        const respData = await axios({
            'url': '/api/admin/source-of-fund',
            'method': 'get',
            'params': reqData
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
        }
    }
}

export const addSourceOfFund = async (reqData) => {
    try {
        const respData = await axios({
            'url': '/api/admin/source-of-fund',
            'method': 'post',
            'data': reqData
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const updateSourceOfFund = async (reqData) => {
    try {
        const respData = await axios({
            'url': `/api/admin/source-of-fund`,
            'method': 'put',
            'data': reqData
        })
        return {
            status: "success",
            loading: false,
            message: respData.data.message
        }
    } catch (err) {
        return {
            status: 'failed',
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}